import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const RequireRole = ({ allowedRoles = [], children, customMessage, showError = true }) => {
    const [loading, setLoading] = useState(true);
    const [hasAccess, setHasAccess] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkUser = async () => {
            try {
                const res = await axios.get(`${window.REACT_APP_API_ENDPOINT}/api/users/current-user`, { withCredentials: true });
                const userRole = res.data?.user.rol?.nombre || res.data?.user.rol;

                if (allowedRoles.includes(userRole)) {
                    setHasAccess(true);
                }
            } catch (err) {
                console.warn("Error al obtener el usuario:", err);
            } finally {
                setLoading(false);
            }
        };

        checkUser();
    }, [allowedRoles]);

    if (loading) return showError ? <div className="p-4">Verificando permisos...</div> : null;

    if (!hasAccess) {
        if (!showError) return null;
        
        return (
            <div className="p-6 text-center border border-red-300 bg-red-50 text-red-700 rounded-md shadow-md max-w-xl mx-auto mt-10">
                <h2 className="text-xl font-bold mb-2">Acceso denegado</h2>
                <p className="mb-4">
                    {customMessage || 'Esta sección está reservada para usuarios con permisos especiales.'}
                </p>
                <button
                    onClick={() => navigate('/')}
                    className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
                >
                    Volver a la página principal
                </button>
            </div>
        );
    }

    return children;
};

export default RequireRole;


